// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import RTravelWithStars from '../_raw/ui/icon_r_travel_with_stars.svg';
import withIconProps from '../withIconProps';

export default withIconProps(RTravelWithStars);
